import { ModelSagres } from "@/types/model-sagres";

export class QuestionarioIegm extends ModelSagres {
  Id: number;
  CodigoUg: number;
  Exercicio: number;
  Questionario: string;
  UrlQuestionario: string;
  icon = "clipboard-question";

  /**
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.Id = obj.Id;
      this.CodigoUg = obj.CodigoUg;
      this.Exercicio = obj.Exercicio;
      this.Questionario = obj.Questionario;
      this.UrlQuestionario = obj.UrlQuestionario;
    }
  }
}
